import React, {useEffect,useState} from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';
import DialogYesNo from '../lib/dialog_yes_no';
import Cookies from 'js-cookie'
                       
import MapAddress from '../lib/mapAdress.js';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
export default function Address_Edit({idAddress,clubid,secteur,ruleWrite,callback}) {


 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    

    const [openQuestion, setOpenQuestion] = React.useState(false);
   

    
    const [defaultAddress, setDefaultAddress] = React.useState(null);

    const [state, setState] = React.useState({
        addressId:"",
        editmode: "",    
        AffAddress: 1,
        addressTable:{fk_club_master: clubid , id:"",Address_To  :"",Address_Type    :"", 
                     Address1 :"",Address2 :"",City  :"", NameOfCompany: "",
                     State :"",Zip :"",Country:"",Note :"", Active: 1
                    },      
    });



    useEffect(() => {



       
        if(idAddress !== "new") 
           updateDisplay(idAddress);
           

    },[idAddress] );

  function updateDisplay(idAddress) { 
        if(idAddress !== "")
        { 
                MyAxios.get(process.env.REACT_APP_API + '/address/secteur/'+ secteur +'/club/'+ clubid+'/getAddressInfo/'+ idAddress)
                .then((res) => {     
            
                    console.log("load edit row ------", res.data[0]);
                    setState({ ...state, addressTable: res.data[0]});
                                    
                    setDefaultAddress(res.data[0].Address1 + " " + res.data[0].City);
                
            
                })
                .catch((error) => {
                    console.log("ERROR load id "+idAddress+" ------>" + error);
                });
        }
    }
    
    function SaveChange() { 


    if(idAddress === "new")  
    {
        MyAxios.post(process.env.REACT_APP_API + '/address/secteur/'+ secteur +'/club/'+ clubid+'/add/',state.addressTable)              
        .then((res) => {       
                console.log(res)
                if(res.status === 200)    
                {
                    alert("Sauvegarde complété")
                    callback();
                }                   
                else      
                    alert("Erreur sauvegarde") 
                
            })
            .catch((error) => {
                console.log(error)
                alert("Erreur sauvegarde")
            });
    }
    else
    {
        MyAxios.post(process.env.REACT_APP_API + '/address/secteur/'+ secteur +'/club/'+ clubid+'/set/'+ idAddress,state.addressTable)    
        .then((res) => {       
            console.log(res)
            if(res.status === 200)    
                alert("Sauvegarde complété")
            else      
                alert("Erreur sauvegarde") 
            
        })
        .catch((error) => {
            console.log(error)
            alert("Erreur sauvegarde")
        });
    }
}



    function DialogResponse(response)
    {
     
        if(response === true)
        {
            if(state.addressTable.id != undefined)
            {
               
                MyAxios.get(process.env.REACT_APP_API + '/address/secteur/'+ secteur +'/club/'+ clubid+'/delete/' + state.addressTable.id)              
                .then((res) => {       
                        console.log(res)
                        if(res.status === 200)    
                        {
                            alert("Sauvegarde complété")
                            callback();
                        }   
                        else      
                            alert("Erreur sauvegarde") 
                        
                    })
                    .catch((error) => {
                        console.log(error)
                        alert("Erreur sauvegarde")
                    });
            }

        }

    }

    function onCloseDialog()
    {
        setOpenQuestion(false);
    }

    function DeleteAdresse() { 
      
        setOpenQuestion(true);
      
    }


    function getButtonAddSave()
    {
       if(ruleWrite === true)
       {
           return(<> 
                       <Button onClick={SaveChange} variant="containedFifth" >ENREGISTRER</Button>  
                       <Button onClick={DeleteAdresse} variant="containedFifth" sx={{ m: 2 }} >SUPPRIMER</Button>  
                  </>   );


        }
    }
       
    function handleChangeAddressTable(event) {
         const value = event.target.value;
         console.log(event.target.id);
         let items = state.addressTable;
         items[event.target.id] = value;
         setState({
           ...state, "addressTable"  : items,
         });
    }

    function ChangeAddressFieldCallBack(AddressFound) { 
       
        //************* ereur *-***/
       
        let items = []; 
        let original =  state.addressTable;
        console.log("Callback AddressFound:", AddressFound);
        AddressFound['address_components'].forEach((elementAddress) => {
            // Utilisez un switch case pour effectuer différentes actions en fonction de chaque élément
            //console.log(elementAddress.types[0]);
            switch (elementAddress.types[0]) {
              case 'subpremise':
                items["subpremise"] = elementAddress.types[0].long_name;
                break;
              case 'street_number':
                items["street_number"] = elementAddress.long_name;
                break;
              case 'route':
                items["route"] = elementAddress.long_name;
                break;
              case 'locality':
                items["locality"] = elementAddress.long_name;
                break;
              case 'administrative_area_level_3':
                items["administrative_area_level_3"] = elementAddress.long_name;
                break;
              case 'administrative_area_level_2':
                items["administrative_area_level_2"] = elementAddress.long_name;
                break;
              case 'administrative_area_level_1':
                items["administrative_area_level_1"] = elementAddress.short_name; // QC / ON
                break;
              case 'country':
                items["country"] = elementAddress.short_name;  // CA  pour canada
                break;
              case 'postal_code':
                items["postal_code"] = elementAddress.long_name;
                break;
            }
      });
  

     

       original.Address1 =  items["street_number"] + " " +  items["route"];  // address
       original.City = items["locality"]; // ville
       original.Zip = items["postal_code"]; // postal code
       original.State = items["administrative_area_level_1"]; // QC / ON ...
       original.Country = items["country"]; // CA  pour canada
       original.Address3 = items["administrative_area_level_3"]; // CA  pour canad
       original.Address4 = items["administrative_area_level_3"]; // CA  pour canad        
       original.Address5 =  AddressFound['types'];  // précision;
     //  alert(original.location_type);
        setState({
          ...state, "addressTable"  : original,
        });
   }


   
function handleChangeNote(event) {
        const value = event.target.value;        
        
        let items = state.addressTable;
        items["Note"] = value;

        setState({
          ...state, "addressTable"  : items,
        });
   

}

    return (
        <div>
            <Box  sx={{display: 'flex', flexDirection: 'row' }} >
                 
                  
                    


                    <Grid container spacing={2}>   
                        <Grid item xs={12}  style={{textAlign: "center"}} >
                            <Box borderRadius="borderRadius" > 
                            <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Type d'adresse</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"                                                                 
                                    onChange={handleChangeAddressTable}
                                    value={state.addressTable.Address_To}                                        
                                >
                                    <FormControlLabel  value="Principale" control={<Radio id="Address_To" />} label="Principale" />
                                    <FormControlLabel  value="Réunion" control={<Radio id="Address_To" />} label="Réunion" />   
                                
                                </RadioGroup>
                            </FormControl>
                            </Box>
                            
                        </Grid> 

                            
                        <Grid item xs={6} >    
                            <MapAddress style={{height : '1000px'}}  defaultAddress={defaultAddress} changeAddress={ChangeAddressFieldCallBack} />
                        </Grid>

                        <Grid item xs={6} >
                            <Grid item   >
                                <Card sx={{ maxWidth: '95%' , margin:'10px' }} key={"AddCard" + state.addressTable.addressId}>                        
                                    <CardContent >
                                    <Typography gutterBottom variant="h7" component="div">
                                    <h4>Adresse Complète</h4>                            
                                    </Typography>
                                    <Typography variant="h6" color="text.secondary"> 
                                        Province:{state.addressTable.State} <br />  
                                        Pays:{state.addressTable.Country} <br />                      
                                        Ville:{state.addressTable.City  }  <br />
                                        Adresse: {state.addressTable.Address1  }<br />                                                              
                                        Code postal:{state.addressTable.Zip  }   <br />   
                                    </Typography>
                                    </CardContent>                                
                                </Card>
                            </Grid > 
                            
                            <Grid item   >
                            
                                 <TextField   sx={{   margin:'10px' }} id="Notess"  onChange={handleChangeNote} value={state.addressTable.Note}   label="Autres informations pertinantes (local, étages, porte arrières...)" fullWidth  /> 

                            </Grid > 
                        </Grid >
                         <Grid item xs={12}  style={{textAlign: "right"}} >
                            {getButtonAddSave()}  
                         </Grid > 
                        

                </Grid >
           </Box>


           
                         

            <DialogYesNo question="Voulez-vous vraiment supprimer cette adresse?" onAnswer={DialogResponse} open={openQuestion} onClose={onCloseDialog}  />
           

           
           </div>
       
    );    
}

